import { inject, Injectable } from '@angular/core';
import type { TranslocoMissingHandler, TranslocoMissingHandlerData } from '@jsverse/transloco';
import { DefaultMissingHandler } from '@jsverse/transloco';
import { dxMissingTranslationSink } from './dx-sinks';

@Injectable()
export class DxMissingTranslationHandler implements TranslocoMissingHandler {
  private readonly defaultHandler = new DefaultMissingHandler();

  private readonly sink = inject(dxMissingTranslationSink, { optional: true });

  /**
   * Handles a missing translation key.
   *
   * @param {string} key - The key Transloco could not resolve.
   * @param {TranslocoMissingHandlerData} data - Active Transloco configuration.
   * @returns {string} The value Transloco should render.
   */
  public handle(key: string, data: TranslocoMissingHandlerData): string {
    this.sink?.(key);
    return this.defaultHandler.handle(key, data);
  }
}
